













































import { Vue, Component, Prop } from 'vue-property-decorator';
import { RgCategoryFilter, DateRangeFilter, ArchiveFilter, TagFilter, TextInput } from '../components/filters';

@Component({
    components: {
        RgCategoryFilter,
        DateRangeFilter,
        ArchiveFilter,
        TagFilter,
        TextInput
    }
})
export default class ManageSelector extends Vue {
    // 筛选条件
    knowledgeFilter: any = {
        ctiNameList: [],
        archiveIds: [],
        labels: [],
        ticketId: '',
        questionDesc: '',
        createdTimeRange: []
    };

    searchLoading: boolean = false;

    /**
     * 按钮禁用状态
     */
    @Prop({ type: Boolean, default: false })
    disabled: boolean;

    emitChange() {
        console.log('知识管理筛选条件变化:', this.knowledgeFilter);
        this.$emit('filter-change', this.knowledgeFilter);
    }

    /**
     * 打开生成学城文档弹窗
     */
    handleGenerateKmDoc() {
        this.$emit('generate-km-doc');
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
